import { BasePostRequest } from './core/basePostRequest';
import { Authentication } from './core/baseRequest';
import { LocaleCode } from 'acscp/translations';
import { CreateAccountResponse, CreateAccountResponseDynamicType } from 'acscp/api/models/createAccountResponse';

export class CreateAccountRequest extends BasePostRequest<CreateAccountResponse> {
    constructor(
        public firstName: string,
        public surname: string,
        public countryOfResidence: string,
        public stateOfResidence: string,
        public username: string,
        public emailAddress: string,
        public callingCodeCountry: string,
        public telephoneNumber: string,
        public password: string,
        public languageCode: LocaleCode,
        public redirectTo?: string) {
        super('users/create-account',
            {}, {
                firstName,
                lastName: surname,
                countryOfResidence,
                stateOfResidence,
                email: username,
                emailAddress,
                callingCodeCountry,
                telephoneNumber,
                password,
                languageCode,
                redirectTo
            }, CreateAccountResponseDynamicType, Authentication.None);
    }
}
